import React from 'react';
import { Icon } from '@tviklax/ui-components';
import { UploadContainer, UploadIconWrapper, UploadTitle, UploadSubtitle } from './FileUpload.styles';

interface FileUploadProps {
    label: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({ label }) => {
    return (
        <div style={{ width: '100%' }}>
            <UploadContainer>
                <UploadIconWrapper>
                    <Icon name="Upload" size={40} />
                </UploadIconWrapper>
                <UploadTitle>{label || 'Click to upload or drag and drop'}</UploadTitle>
                <UploadSubtitle>SVG, PNG, JPG or GIF (max. 800x400px)</UploadSubtitle>
            </UploadContainer>
        </div>
    );
};
